module.exports = __webpack_public_path__ + "static/img/acrysil.b124c2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/acrysil.png
// module id = Cf4I
// module chunks = 1